import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            © Copyright François Chevalier
        </footer>
    );
};

export default Footer;